<template>
  <div class="layout-topbar w-full">
    <div
      class="layout-topbar__content relative flex items-center"
      :class="{
        'justify-between': $slots.left && $slots.right,
        'justify-end': !$slots.left && $slots.right,
      }"
    >
      <div class="flex min-w-0 items-center">
        <slot name="left" />
      </div>

      <div class="flex items-center">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout-topbar {
  z-index: 10;
  background-color: var(--p-content-background);

  &__content {
    height: $topbar-height;
    padding: 0 $layout-gap;

    &::after {
      content: "";
      position: absolute;
      right: $layout-gap;
      bottom: 0;
      width: calc(100% - $layout-gap * 2);
      height: 1px;
      background-color: var(--p-content-border-color);
    }
  }
}
</style>
